import { RebuildNotice } from '@/components/RebuildNotice'
export default function Page() { return <RebuildNotice title="Loads" hint="FreightLoad — moderation, soft-delete." /> }
